import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const VideoSelectionContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 20px;
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
`;

const SelectionTitle = styled.h1`
  color: #fff;
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
  margin: 0;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  width: 100%;
  height: 100%;
  flex: 1;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
`;

const VideoCard = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 0;
  max-height: 100%;
  overflow: hidden;
  
  &:hover {
    background: rgba(255, 255, 255, 0.15);
    transform: translateY(-3px);
  }
`;

const ThumbnailContainer = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Thumbnail = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const VideoNumber = styled.div`
  position: absolute;
  top: 6px;
  left: 6px;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 3px 6px;
  border-radius: 8px;
  font-size: 0.6rem;
  font-weight: bold;
`;

const SelectButton = styled(motion.button)`
  background: var(--primary-gradient);
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  word-break: keep-all;
  flex-shrink: 0;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    padding: 6px 12px;
  }
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 3px 10px rgba(255, 107, 107, 0.4);
  }
`;

const DripVideoSelectionPhase = ({ dripData, onVideoSelect }) => {
  return (
    <VideoSelectionContainer
      key="selection"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      {/* <SelectionTitle>드립칠 영상을 선택하세요</SelectionTitle> */}
      <VideoGrid>
        {dripData.map((video, index) => (
          <VideoCard
            key={video.videoId}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => onVideoSelect(index)}
          >
            <ThumbnailContainer>
              <Thumbnail 
                src={`https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`}
                alt={`드립 영상 ${index + 1}`}
                onError={(e) => {
                  e.target.src = `https://img.youtube.com/vi/${video.videoId}/hqdefault.jpg`;
                }}
              />
              <VideoNumber>{index + 1}번</VideoNumber>
            </ThumbnailContainer>
            <SelectButton
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {video.isDrip ? "드립치고 응모하기" : "응원하고 응모하기"}
            </SelectButton>
          </VideoCard>
        ))}
      </VideoGrid>
    </VideoSelectionContainer>
  );
};

export default DripVideoSelectionPhase; 